import React, { useMemo } from 'react';
import useBrand from '../../hooks/context/useBrand';
import { platformAgentThemeVars } from '../../services/platform-agent/platformAgentTheme';

/**
 * The root of everything the platform agent (Amigo) shows: @foodamigos/ui components inside it take the dashboard's
 * brand (the partner's colour, FoodAmigos green, or neutral), and nothing outside it changes. The package's CSS is
 * loaded once in src/index.jsx, before the app's own, and only styles `fa-` classes.
 */
export default function PlatformAgentRoot({ id, className, style: extraStyle, children }) {
  // BrandProvider's value is the brand itself (with isWhiteLabel, … added), as in Header and Sidebar.
  const brand = useBrand();
  const themeVars = useMemo(() => platformAgentThemeVars(brand), [brand]);
  const style = useMemo(() => (extraStyle ? { ...themeVars, ...extraStyle } : themeVars), [themeVars, extraStyle]);

  return (
    <div id={id} data-platform-agent-root="" className={className} style={style}>
      {children}
    </div>
  );
}
